import React, {useState} from 'react'
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import { Shimmer, ThemeProvider, mergeStyles, ActionButton, SpinnerSize, Icon, TooltipOverflowMode, TooltipHost } from '@fluentui/react';
import CLabel from '../../../../../components/Common/CLabel';
import { useGetRelatedConceptById } from '../../../../../hooks/services/sBook/useOfRelatedConcept'
import AditionalInfoModal from './AditionalInfoModal';
import { useBoolean } from '@fluentui/react-hooks';
import moment from 'moment';
import NoDataLayer from '../../../../Common/NoDataLayer';
import { isNullUndefined } from '../../../../../common/Helpers';
import Loading from '../../../../Templates/Site/Loading';
import { __onGoToBook } from '../../../../../common/SystemRedirections';

function FieldglassIntegration(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_FieldglassMode = props.fieldglassMode !== null && props.fieldglassMode !== undefined ? props.fieldglassMode : false;
    const inputParam_BookRelatedConceptItem = props.bookRelatedConceptItem !== null && props.bookRelatedConceptItem !== undefined ? props.bookRelatedConceptItem : null;
    const inputParam_Book = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
    

    //Parametros de componente.
    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);


    const [relatedConceptItem, setRelatedConceptItem] = useState({id: null});
    useGetRelatedConceptById(inputParam_BookRelatedConceptItem !== null ? inputParam_BookRelatedConceptItem.projectId !== null ? inputParam_BookRelatedConceptItem.projectId : inputParam_BookRelatedConceptItem.contractId : null, relatedConceptItem, setRelatedConceptItem, inputParam_BookRelatedConceptItem !== null ? inputParam_BookRelatedConceptItem.relatedConceptTypeId : null)

    

    const wrapperClass = mergeStyles({
        padding: 2,
        selectors: {
            '& > .ms-Shimmer-container': {
                margin: '10px 0',
            },
        },
    });

    //Funciones de componente.

    //Eventos de componente.

    //Render de componente.
    return (
        <>
            {
                inputParam_FieldglassMode && 
                <Card className='first-line-card-height h-auto'>
                    <Card.Header>
                        <Card.Title className="d-flex justify-content-between">
                            <div>
                                <h4><b>{t('data-lang-boxname-fieldglassintegration')}</b></h4>
                            </div>
                        </Card.Title>
                    </Card.Header>
                    <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                        <div className='book-toolbar'>
                                    
                        </div>
                    </Card.Footer>
                    <Card.Body className='h-auto'>
                        <Row>
                            <ThemeProvider className={wrapperClass}>
                                <Shimmer />
                                <Shimmer />
                                <Shimmer />
                                <Shimmer />
                                <Shimmer />
                                <Shimmer />
                            </ThemeProvider>
                        </Row>
                    </Card.Body>
                    <Card.Footer>

                    </Card.Footer>
                </Card>
            }
            {
                !inputParam_FieldglassMode && 
                <Card className='first-line-card-height h-100'>
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            <b>{t('data-lang-boxname-relatedconcept')}</b>
                        </Card.Title>
                    </Card.Header>
                    <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    <div className='book-toolbar'>
                        {
                            relatedConceptItem.id !== null && relatedConceptItem.id !== 0 && inputParam_BookRelatedConceptItem && (inputParam_BookRelatedConceptItem.relatedConceptTypeId === 2) &&
                            <ActionButton className="float-end" onClick={showModal} iconProps={{ iconName: 'AddNotes' }} allowDisabledFocus disabled={false} checked={false}>
                                { t('data-lang-btn-aditionalinfo') }
                            </ActionButton>
                        }
                    </div>
                    </Card.Footer>
                    {
                        (relatedConceptItem.id !== null && relatedConceptItem.id !== 0 && inputParam_BookRelatedConceptItem) && 
                        <>
                            <Card.Body className='h-100'>
                                {
                                    relatedConceptItem.id !== null && relatedConceptItem.id !== 0 && inputParam_BookRelatedConceptItem && (inputParam_BookRelatedConceptItem.relatedConceptTypeId === 2) &&
                                    <>
                                        <Row>
                                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                                <CLabel labelText={t('data-lang-lbl-code')} labelValue={relatedConceptItem.contractCode} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                            </Col>
                                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                                <CLabel labelText={t('data-lang-lbl-suppliercode')} labelValue={relatedConceptItem.legalEntitySupplierCode} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                                <CLabel labelText={t('data-lang-lbl-startdate')} labelValue={ moment(relatedConceptItem.startDate).format('DD/MM/YYYY')} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                            </Col>
                                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                                <CLabel labelText={t('data-lang-lbl-enddate')} labelValue={ moment(relatedConceptItem.endDate).format('DD/MM/YYYY')} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                            </Col>
                                            <AditionalInfoModal bookObject={inputParam_Book}  relatedConceptItem={relatedConceptItem} isModalOpen={isModalOpen} showModal={showModal} hideModal={hideModal} />
                                        </Row>
                                    </>
                                }
                                {
                                    relatedConceptItem.id !== null && relatedConceptItem.id !== 0 && inputParam_BookRelatedConceptItem && (inputParam_BookRelatedConceptItem.relatedConceptTypeId === 1) &&
                                    <Row>
                                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                            <CLabel labelText={t('data-lang-lbl-code')} labelValue={relatedConceptItem.projectCode} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                        </Col>
                                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                            <CLabel labelText={t('data-lang-lbl-name')} labelValue={relatedConceptItem.name} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                                        </Col>
                                    </Row>
                                }
                                {
                                    relatedConceptItem.id !== null &&
                                    <Row className="mt-3 border-top pt-2">
                                        <Col>
                                            <h5>{t('data-lang-lbl-linkedbooks')}</h5>

                                            <Row>
                                                <Col
                                                    className={
                                                        inputParam_Book?.l_book_linked?.length === 0
                                                            ? 'col-auto mx-auto'
                                                            : ''
                                                    }
                                                >
                                                    {inputParam_Book?.l_book_linked?.map((item) => (
                                                        <div
                                                            key={item.bookId}
                                                            className="cursor-pointer"
                                                            onClick={() => __onGoToBook(item.bookId)}
                                                        >
                                                            <div
                                                                className="d-flex align-items-center gap-2"
                                                                style={{ minWidth: 0 }}
                                                            >
                                                                <div className="flex-shrink-0">
                                                                    <TooltipHost
                                                                        content={
                                                                            <div>
                                                                                <div>{item.mainBook === true ? t("data-lang-lbl-pdf-mainbook") : t("data-lang-lbl-pdf-auxiliar")}</div>
                                                                            </div>
                                                                        }
                                                                    >
                                                                        <Icon
                                                                            iconName={
                                                                                item.mainBook
                                                                                    ? 'AdminPLogoInverse32'
                                                                                    : 'AdminALogoInverse32'
                                                                            }
                                                                        />
                                                                    </TooltipHost>
                                                                </div>

                                                                <div className="flex-shrink-0">
                                                                    {item.bookCode}
                                                                </div>

                                                                <div
                                                                    className="flex-grow-1"
                                                                    style={{ minWidth: 0 }}
                                                                >
                                                                    <TooltipHost
                                                                        content={item.bookName}
                                                                        overflowMode={TooltipOverflowMode.Self}
                                                                        styles={{
                                                                            root: {
                                                                                display: 'block',
                                                                                width: '100%',
                                                                                overflow: 'hidden',
                                                                                whiteSpace: 'nowrap',
                                                                                textOverflow: 'ellipsis'
                                                                            }
                                                                        }}
                                                                    >
                                                                        {item.bookName}
                                                                    </TooltipHost>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}

                                                    {inputParam_Book?.l_book_linked?.length === 0 && (
                                                        <div>{t('data-lang-lbl-nodata')}</div>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                }
                                {
                                    relatedConceptItem.id === null &&
                                    <NoDataLayer display={true} />
                                }
                            </Card.Body>
                            <Card.Footer>
                            </Card.Footer>
                        </>
                    }
                    {
                        !(relatedConceptItem.id !== null && relatedConceptItem.id !== 0 && inputParam_BookRelatedConceptItem) && 
                        <Card.Body className="book-party-roles-form-body h-100">
                            <Row className="h-100">
                                <Col className="d-flex align-items-center justify-content-center">
                                    <Loading
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={false}
                                        inputParam_Width={'35px'}
                                        inputParam_Height={'35px'}
                                        inputParam_Left={""}
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ColClassName={"me-2"}
                                        inputParam_MarginLeft={"auto"}
                                        inputParam_SpinnerSize={SpinnerSize.medium} />
                                </Col>
                            </Row>
                        </Card.Body>
                    }
                </Card>
            }
        </>
    );
}

export default FieldglassIntegration;